module.exports = __webpack_public_path__ + "e.no2.9541abe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/e.no2.jpg
// module id = YudL
// module chunks = 0